var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongDiannao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1.5a1 1 0 00-1 1v8a1 1 0 001 1h3.262l-.726 1.814-.274.686H11.239l-.274-.686-.726-1.814H13.5a1 1 0 001-1v-8a1 1 0 00-1-1h-11zm4.339 10h2.323l.6 1.5H6.239l.6-1.5zm3-1H13.5v-8h-11v8H9.84z",
    fill: "#3F465C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 13,
    width: 9,
    height: 1,
    rx: 0.5,
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_diannao.38c4bf82.svg";
export { SvgTongyongDiannao as ReactComponent };